import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("LimitStore");

const urls = {
  limitById: (limitId) => `/bnpl/limit/${limitId}`,
  limitListByMerchant: (merchantId, query) =>
    `/bnpl/limit/by-merchantId/${merchantId}?${query}`,
  cancelLimit: (limitId) => `/bnpl/limit/cancel/${limitId}`,
  export: `/bnpl/limit/merchant/export`,
};

/**
 * Limit store
 */

const initState = () => {
  return {
    limitList: [],
    limitData: {},
  };
};

const actions = {
  fetchList: async ({ commit, rootGetters }, query) => {
    try {
      const merchantId = rootGetters["session/merchantId"];
      console.log(`merchantId: ${merchantId}`);
      const axios = await network.connection();
      let { data } = await axios.get(
        urls.limitListByMerchant(merchantId, query)
      );
      commit("saveList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchOne: async ({ commit }, limitId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.limitById(limitId));
      commit("saveOne", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  cancelLimit: async ({}, limitId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.put(urls.cancelLimit(limitId));
      console.log(data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  exportLimits: async ({}) => {
    try {
      const axios = await network.connection();
      let blob = await axios.get(urls.export, {
        responseType: "blob",
        timeout: 120000,
      });
      return blob.data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveList: (state, listData) => {
    Vue.set(state, "limitList", listData);
  },
  saveOne: (state, data) => {
    Vue.set(state, "limitData", data);
  },
};

const getters = {
  list: (state) => {
    return state.limitList;
  },
  get: (state) => {
    return state.limitData;
  },
  getLimitLanes: (state) => {
    return state.limitData.limitLanes;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
